import CheckoutConfirmation from 'theme/pages/CheckoutConfirmation.vue'

export const routes = [
  { name: 'checkout-confirmation', path: '/checkout-confirmation', component: CheckoutConfirmation }
]
